import styled from 'styled-components';

const Container = styled.div`
  z-index: 1;
  position: fixed;
  inset: 0;
  background-color: rgba(0,0,0,0.4);
  display: flex;
  flex-direction: column;
  justify-content: flex-end;

  width: 100%;
  max-width: 600px;
  margin-inline: auto;
`;

const Content = styled.div`
  border-radius: 20px 20px 0 0;
  overflow-y: auto;
  width: 100%;
  min-height: 122px;
  background-color: #fefefe;

  display: flex;
  flex-direction: column;

  container-type: inline-size;

> div {
    display: grid;
    grid-auto-flow: column;
    grid-auto-columns: minmax(100px, 1fr);
    gap: 20px;
    padding: 20px;

    @container (max-width: 400px) {
      grid-auto-flow: row;
      grid-template-columns: 1fr;
    }
  }
`;


const ShareOption = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

const ClickableArea = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  cursor: pointer;
  > small {
    text-align: center;
  }
`;


export { Container, Content, ShareOption, ClickableArea };
